import { Component, EventEmitter, Input, OnInit, Output, } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { PaymentMethod, Transaction, TransactionState } from '@fry/payments/lib';
import { TracksOperationProgress } from '@fry/components/common';

/**
 * Admin confirmation that the payment has been received
 *
 * This component is used in case of manual confirmation of the payment or
 * when off-line payment method is selected.
 */
@Component({
    selector: 'eas-payments-capture-form',
    templateUrl: './transaction.capture.form.component.html',
    standalone: false
})
export class TransactionCaptureFormComponent implements OnInit, TracksOperationProgress {

    @Input() isOperationInProgress = false;
    @Input() transaction!: Transaction;
    @Input() paymentMethods: PaymentMethod[] = [];
    @Output() confirm = new EventEmitter<void>();

    public form: UntypedFormGroup;
    public availablePaymentMethods: PaymentMethod[] = [];

    constructor() {
        this.form = new UntypedFormGroup({
            method: new UntypedFormControl('', Validators.required)
        });
    }

    ngOnInit() {
        this.availablePaymentMethods =
            this.paymentMethods.filter(method => !method.isCard());

        if (this.transaction.state !== TransactionState.Pending && !this.transaction.method.isCard()) {
            this.form.patchValue({ method: this.transaction.method.id });
        }
    }

    onConfirm() {
        this.transaction.method =
            this.availablePaymentMethods.find(pm => pm.id === this.form.value['method']);
        this.confirm.emit();
    }
}
